import { render, staticRenderFns } from "./AssignmentRequisitionItem.vue?vue&type=template&id=5eac3e80&"
import script from "./AssignmentRequisitionItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentRequisitionItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRequisitionItem.vue?vue&type=style&index=0&id=5eac3e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports